import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard from "./scoreboard";
import {
    dotPad,
    startFlashingTimeStar,
    stopFlashingTimeStar,
    upperFirst,
} from "./util";

export class SetScore extends Handler {
    private side: string;
    private sideF: "Home" | "Guest";
    private score: number = 0;

    constructor(side: string) {
        super();

        this.side = side;
        this.sideF = upperFirst(this.side) as "Home" | "Guest";
        this.score = scoreboard[`get${this.sideF}Score`]();
    }

    boot(): void {
        startFlashingTimeStar();

        this.update();
    }

    public onPop(): void {
        stopFlashingTimeStar();
    }

    public update(): void {
        const sideLetter = this.side[0].toUpperCase();
        display.line2(`${sideLetter}. SCORE  ${dotPad(this.score, 3)}`);
    }

    onKeypad(num: string): void {
        this.score = (this.score * 10 + parseInt(num)) % 1000;
        this.update();
    }

    onEnter(): void {
        scoreboard[`set${this.sideF}Score`](this.score);
        clock.popHandler();
    }

    onClear(): void {
        clock.popHandler();
    }
}
